import { MdOutlineEnergySavingsLeaf } from "react-icons/md";
import { CounterType } from "../CounterType";
import { ICounter } from "./types";
import { IoMdFlash } from "react-icons/io";

export const CounterIcon = (props: ICounter) => {

    if (props.counterType === CounterType.Producer || props.counterType === CounterType.FeedOut)
        return <MdOutlineEnergySavingsLeaf size="100%"></MdOutlineEnergySavingsLeaf>


    return <IoMdFlash size="100%"></IoMdFlash>;
}